import { rollbar } from "../../utils/rollbar";

const fetchLocation = async () => {
  try {
    const response = await fetch(`${window.location.origin}/ink/sb-localinfo`);
    if (!response.ok) {
      rollbar.error('Failed to fetch sb-localinfo ', {
        status: response.status,
        text: await response.text(),
      })
      return null;
    }
    return await response.json();
  } catch (err) {
    rollbar.error('Error occurred while fetching Custom Ink local info:', err);
    return null;
  }
};

const fetchYextInformation = async (coordinates: string[]) => {
  const coordinatesVar = coordinates[0] + ',' + coordinates[1];
  const api_key = '2181ea8f899d7b657336dbb29c643737';
  try {
    const response = await fetch(
      `https://liveapi.yext.com/v2/accounts/me/entities/geosearch?v=20190117&api_key=${api_key}&location=${coordinatesVar}&radius=15&filter=%7B%0A%20%20'c_show'%3A%20%7B%0A%20%20%20%20'%24eq'%3A%20true%0A%20%20%7D%0A%7D`,
    )
    if (!response.ok) {
      rollbar.error('Failed to fetch liveapi', {
        status: response.status,
        text: await response.text(),
      })
      return null;
    }
    return await response.json()
  } catch (err) {
    rollbar.error('Error fetching liveapi:', err)
    return null;
  }
};

const formatPhone = (phoneNumber: string) => {
  return `${phoneNumber.substring(2, 5)}-${phoneNumber.substring(5, 8)}-${phoneNumber.substring(8, 12)}`;
};

export const getStoreInformation = async () => {
  const location = await fetchLocation();
  if (location !== null) {
    const yextResponse = await fetchYextInformation(location.coordinates);
    if (yextResponse !== null && yextResponse.response.count !== 0) {
      const store = yextResponse.response.entities[0];
      if (store && store.address && store.address.city && store.mainPhone) {
        return {
          name: `${store.address.city}, ${store.address.region}`.replace(/\"/g, ''),
          landingPageUrl: store.landingPageUrl,
          address: store.address,
          phone: formatPhone(store.mainPhone),
        };
      }
    }
  }
  return null;
};
